import React from 'react';

import { BlankTextButton } from './buttons.styles';

export const TextButton = (props: React.DetailsHTMLAttributes<HTMLButtonElement>) => {
  const { children, ...buttonProps } = props;

  return (
    <BlankTextButton type="button" {...buttonProps}>
      {children}
    </BlankTextButton>
  );
};
